import { create } from 'zustand';

interface HcoCharacteristicsScopeState {
  isDisabled: boolean;
  setDisabled: (disabled: boolean) => void;
}

export const useHcoCharacteristicsScopeStore = create<HcoCharacteristicsScopeState>()(set => ({
  isDisabled: false,
  setDisabled: disabled => set({ isDisabled: disabled }),
}));

export const useIsHcoCharacteristicsDisabled = (): boolean =>
  useHcoCharacteristicsScopeStore(state => state.isDisabled);
